export default {
  myAccount: {
    myAccount: '我的账户',
    nickName: '昵称',
    nickNamePlaceholder: '请输入昵称',
    birthdayPlaceholder: '请选择日期',
    birthday: '生日',
    emailSubscribe: '您是否希望接收促销信息？',
    uid: '用户唯一码',
    nicknameValidFail: "昵称不能包含特殊字符"
  },
  myOrder: {
    myOrder: '我的订单',
    payEndTime: "支付期限 ",
    allOrder: '所有订单',
    pendingPaymentOrder: '待支付',
    todoOrder: '待处理',
    shippedOrder: '待收货',
    doneOrder: '已完成',
    orderDate: '下单时间',
    orderNo: '订单编号',
    orderPayDate: '剩余支付时间',
    orderCancel: '取消订单',
    orderCancelSuccess: '取消成功',
    orderDetail: '订单详情',
    orderExpress: '查看物流信息',
    orderAllProduct: '全部商品',
    orderPayment: '付款方式',
    orderPayTips: '付款方式',
    orderPaymentTips: '请在 {date} 内完成付款。',
    orderPaymentNoPay: '支付超时',
    addressTitle: '收货地址',
    addressUserName: '收货人',
    address: '收货地址',
    addressPost: '邮编',
    addressTel: '联系电话',
    remarks: '订单留言',
    productTitle: '商品信息',
    deliveryNum: '大约{num}个包裹',
    channelDate: '指定收货时间',
    delivery: '运输',
    noOrder: '暂无订单记录',
    orderExpressTitle: "物流信息",
    cancelTips: "取消订单后不可返回，是否继续操作？",
    cancelBtn1: "确认取消",
    cancelBtn2: "我再想想",
    orderPointsTips: "订单完成后可获得积分",
    productTotal: "商品小计",
    expressFree: "运费",
    serviceFree: "货到付款手续费",
    promotionFree: "促销",
    couponFree: "优惠券",
    pointsFree: "积分抵扣",
    totalFree: "总价",
    productCode: '商品编号',
    productOptionName: '规格',
    productNum: '数量',
    productReturn: '退换商品',
    productReturnDetail: '查看退换详情',
    alteration: '变更',
    package: '包裹',
    noExpressInfo: '无快递信息',
    reBuy: "再次购买"
  },
  myCoupon: {
    myCoupon: '我的优惠券',
    derate: '{num} OFF',
    discount: '折扣',
    unconditional: '满任意金额可以使用',
    useCondition: '满{money}可以用',
    usefulLife: '使用有效期：',
    freeTransport: '包邮',
    commodityCoverage: '商品范围：',
    allProductUse: '全部商品',
    portionProductUse: '部分商品',
    portionProductCanNotUse: '部分商品不可用',
    freeTransportArea: '包邮区域：',
    allArea: '全部区域',
    except: '除外',
    immediateUse: '立即使用',
    usable: '可用',
    used: '已使用',
    overdue: '已过期',
    noCoupon: '暂无优惠券',
    getNow: '立即领取',
    limitGet: '限领：',
    unit: '张',
    couponUseTimePrompt1: '领券当日开始{time}天内',
    couponUseTimePrompt2: '领券次日开始{time}天内',
    freeTransportCoupon: '包邮券',
    useCondition1: '满{num}',
    useCondition2: '可以用'
  },
  productEvaluationList: {
    productEvaluationList: '商品评价',
    predictPointPrompt: '评价后可获得 <span class="predictPointPrompt">{point}</span> 积分',
    awardedPointPrompt: '已获得 <span class="awardedPointPrompt">{point}</span> 积分',
    immediateEvaluation: '立即评价',
    orderDate: '下单时间',
    noEvaluation: '待评价',
    haveEvaluation: '已评价',
    noEvaluationPh: '暂无待评价商品',
    haveEvaluationPh: '暂无已评价商品',
    evaluationDetail: '评价详情',
    productScore: '商品评分',
    yourEvaluation: '您的评价',
    pleaseInputYourEvaluation: '请输入您的评价',
    pictureComment: '晒图',
    uploadPicture: '上传图片',
    submitEvaluation: '提交评价',
    haveEvaluationPrompt: '您已评价，预计将获得 <span class="haveEvaluationPrompt">{point}</span> 积分奖励 ',
    evaluationDate: '评价时间',
    pictureNumPrompt: '共 <span class="pictureNumPrompt">{number1}</span> 张,还能上传 <span class="pictureNumPrompt">{number2}</span> 张',
    allProductHaveEvaluation: '该订单所有商品都已评价',
    star_null: '请选择商品评分',
    evaluation_error: '评价内容必须在 5 至 200 字符之间'
  },
  myPoint: {
    myPoint: '我的积分',
    myPointTotal: '我的积分总数',
    aboutToExpirePointNumber: '本月底即将过期的积分数',
    addDate: "获得日期",
    incomingsOutgoings: '收入/支出',
    dueDate: "有效截止日期",
    explain: "说明"
  },
  productReturnList: {
    productReturnList: '商品退换货',
    product: '商品',
    applicationDate: '申请时间',
    type: '类型',
    status: '状态',
    returnedGoods: '退货',
    exchangeGoods: '换货',
    returnAmount: '退换数量',
    inProgress: '处理中',
    Processed: '已处理',
    orderInfo: '订单信息',
    orderNo: '订单编号',
    orderDate: '订单日期',
    productInfoAndReason: '商品信息与退换货原因',
    returnType: "退换类型",
    returnReason: "退换原因",
    returnReason1: '没有收到商品',
    returnReason2: '发错商品',
    returnReason3: '错误下单',
    returnReason4: '商品质量问题，赏味期限过期',
    returnReason5: '其他，请说明原因',
    productUnsealing: '商品已开封',
    remark: '备注',
    amount: '数量',
    returnPrompt: '提交表示您已阅读并同意',
    shoppingTerms: '退货换货协议',
    productReturnApply: '申请退换货',
    productReturnDetail: '退换货详情',
    applyReason: '申请原因',
    serviceAnswer: "客服答复",
    submitSuccess: "提交成功"
  },
  addressManagement: {
    addressManagement: '我的收货地址',
    addAddress: '新增地址',
    editAddress: '编辑地址',
    country: "国家",
    postcode: '邮编',
    postcodePh: '请输入邮编',
    area: '地区',
    detailedAddress: '地址',
    consigneeName: '收货人姓名',
    consigneeNamePh: '请输入收货人姓名',
    consigneeNameValidFail: '收货人姓名不能输入特殊字符',
    phone: '联系电话',
    phonePh: '请输入联系电话',
    phoneErr: '请输入正确的联系电话',
    operation: '操作',
    setDefault: '设为默认',
    defaultAddress: '默认地址',
    setDefaultaddAddress: '设为默认收货地址',
    address1: '都道府县',
    address2: '市区町村',
    address3: '详细地址（丁目·番地·建物名·部屋·番号）',
    address3Ph: '请输入详细地址',
    address3w: '详细地址不能包含特殊字符',
    postcodeAutoMatch: '根据邮编自动匹配',
    deleteAddress: '删除地址',
    deleteAddressPrompt: "确定要删除吗?",
    postcodeError: '邮编不存在',
    townPlaceholder: '请选择市区町村',
    noAddress: '暂无收货地址'
  },
  myCollect: {
    myCollect: '我的收藏',
    cancelCollect: '取消收藏'
  },
  memberCenter: {
    logout: '退出账户',
    memberCenter: '会员中心',
    editEmail: '编辑邮箱',
    editPhone: '编辑电话',
    updatePwd: '更新密码',
    newPwd: '新密码',
    newPwdNull: '请输入新密码',
    oldPwd: '原密码',
    oldPwdNull: '请输入原密码',
    pleaseChangeEmail: '新邮箱地址与旧邮箱地址相同，无需修改',
    pleaseChangePhone: '新手机号码与旧手机号码相同，无需修改',
    logoutSuccess: '退出成功'
  }
};